// extracted by mini-css-extract-plugin
export default {"container":"com_29jaW","shape":"com_sha_G3UOw","image":"com_ima_1k70Q","verified":"com_ver_1OkL4","isVerified":"com_isV_15dvs"};